import es from "./es.json";

export default { es };
